module.exports = __webpack_public_path__ + "img/Contact_principle_s.3d51fa98.jpeg";